import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LoginUser } from "../../actions/LoginAction";
import swal from "sweetalert";
import { salesforceSendFormNumber } from "../../actions/StudentAction";

const LoginForm = (props) => {
  const navigate = useNavigate();
  const [formNumber, setFormNumber] = useState({value:'',error:''});
  const [password, setPassword] = useState({value:'',error:''});
  const [loading,setLoading] = useState();

  const validation = () => {
    let formIsValid = true

    if (!formNumber.value) {
        formIsValid = false
        let msg = "Please Enter Your ALLEN Form Number"
        setFormNumber({...formNumber,error:msg})
    }

    if (!password.value) {
        formIsValid = false
        let msg = "Please enter your password"
        setPassword({...password,error:msg})
    }


    if(formIsValid){
        setFormNumber({...formNumber,error:''})
        setPassword({...password,error:''})
    }
    return formIsValid
}

  const utmParams=props.utmParams

  const submitLoginHandler = async(e) => {
    e.preventDefault();

    if(validation()){

        const data = {
          form_num : formNumber.value,
          password: password.value,
          };
          
          setLoading(true)
          try {
            await LoginUser(data).then((res) => {
              let loginDataContain = res.data
              let utmData;
              let formNumData ={
                  form_num : loginDataContain?.form_num
              }
              
              if(utmParams!==null){
                  utmData=Object.assign(formNumData,utmParams)
              }
              if(res.status){
                setLoading(false)
                
                sessionStorage.setItem('token',res.token);
                salesforceSendFormNumber(utmData).then((res) => {
                  console.log('sales')
                })
                swal('Logged In Successfully','','success')
                navigate('/student/dashboard')
              }
              else{
                swal(res.message,'Try Again!','error')
                setLoading(false)
              }
            });
          } catch (error) {
            swal('Something went wrong!','',"error")
            setLoading(false)
          }
    }
    
  };

  return (
    <form onSubmit={submitLoginHandler} className="w-100">
      <div className="mb-3">
        <label htmlFor="formNumber" className="form-label">
          ALLEN Form No.
        </label>
        <input
          type="text"
          className="form-control"
          id="formNumber"
          value={formNumber.value}
          onChange={(e) =>{
            let value = e.target.value
            value = value.replace(/\D/g, '')   
            setFormNumber({...formNumber,value:value,error:''})
        }}
          placeholder="Enter ALLEN form No."
        />
        {formNumber?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{formNumber.error}</small>}

      </div>
      <div className="mb-3">
        <label htmlFor="pass" className="form-label">
          Password
        </label>
        <input
          type="password"
          className="form-control"
          id="pass"
          value={password.value}
          onChange={e => setPassword({...password,value:e.target.value,error:''})}
          placeholder="Enter your password"
        />
        {password?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{password.error}</small>}

      </div>

      <div className="mb-3">
        {/* <button type="submit" className="btn btn-primary d-block w-100">
          Login
        </button> */}
        {loading ? <button className="btn btn-primary w-100 d-block" disabled type="button">
                            <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                                Submitting please wait...</button> : 
                            <button className="btn btn-primary d-block w-100" type="submit">Login</button>}
      </div>
      <p>
        {/* Can’t access your account?{" "} */}
        <Link
          to="/forgot-password"
          className="text-primary text-decoration-none fw-bold"
          title="Reset Password"
        >
          Forgot Password ?
        </Link>
      </p>
    </form>
  );
};

export default LoginForm;
